import { createContext, useContext } from 'react'

export const PageScrollContext = createContext<HTMLElement | undefined>(
  undefined,
)

export const usePageScrollElement = () => useContext(PageScrollContext)
